{
  "edit": {
    "name": "Name *",
    "type": "Type (INT / EXT)",
    "typeShort": "Type",
    "typeUnset": "— not specified —",
    "typeInt": "INT (interior)",
    "typeExt": "EXT (exterior)",
    "typeBoth": "INT/EXT (both)"
  },
  "variantEdit": {
    "name": "Name (optional — derived from time/weather)",
    "namePlaceholder": "Morning, rain, after renovation…",
    "timeOfDay": "Time of day",
    "timePlaceholder": "morning, day, evening, night",
    "weather": "Weather",
    "weatherPlaceholder": "clear, rain, fog…",
    "notes": "Notes (extra lighting/atmosphere nuances — go into variant prompt)",
    "fidelityLabel": "Source image preservation",
    "fidelityReset": "reset",
    "fidelityDefault": "default",
    "fidelityHint": "1.0 — minimal changes (lighting only), 0.0 — maximum freedom (different angle/scale). Empty — project settings value."
  },
  "correction": {
    "title": "Location reference correction",
    "hint": "Describe what to change — a new version will be generated from the current image",
    "placeholder": "For example: make walls brick, add a window on the right, remove the door in the background...",
    "submitting": "Submitting…",
    "generate": "Generate",
    "presets": {
      "moreSpacious": "More spacious"
    }
  },
  "promptPreview": {
    "title": "Reference prompt",
    "variantSuffix": " · variant «{{name}}»",
    "building": "Building prompt…",
    "failed": "Could not build: {{error}}",
    "systemPrompt": "System prompt",
    "userPrompt": "User prompt"
  },
  "references": {
    "title": "Reference versions",
    "base": " · base",
    "variantSuffix": " · variant «{{name}}»",
    "hint": "You can select multiple files. Upload your image or generate a new one. Double-click a version to make it active.",
    "upload": "Upload file",
    "loading": "Loading versions…",
    "empty": "No versions yet. Generate a reference or upload a file.",
    "noPreview": "No preview",
    "active": "Active",
    "uploaded": "Uploaded",
    "generated": "Generated",
    "cleared": "Cleared",
    "correct": "Correct",
    "doubleClickActivate": "Double-click to make active",
    "delete": "Delete",
    "deleteConfirm": "Delete this reference version?"
  }
}
